type ConnectionMap = Record<number, number>;

/**
 * Builds a mapping from original node IDs to new duplicated node IDs.
 * This map is used to rebuild connections between duplicated nodes.
 *
 * @param duplicatedNodes - Array of objects containing originalId and newId pairs
 * @returns A map from original IDs to new IDs
 */
export default function buildConnectionMap(
  duplicatedNodes: Array<{originalId: number; newId: number}>,
): ConnectionMap {
  return duplicatedNodes.reduce((map, {originalId, newId}) => {
    map[originalId] = newId;

    return map;
  }, {} as ConnectionMap);
}
